import type { ToolsTreeNode, ToolsType } from "../../model/types";
import { useEnabledToolsState, useToolsLoading } from "../store/useWorkspaceToolsStore";
import { useToolsTree } from "./useToolsTree";

export type ToolsView =
	| { kind: "loading" }
	| { kind: "unavailable"; reason: "failed" | "absent" }
	| { kind: "tree"; nodes: ToolsTreeNode[] };

type ToolsStatus = "loading" | "failed" | "absent" | "ready";

const useToolsStatus = (): ToolsStatus => {
	const state = useEnabledToolsState();
	const loading = useToolsLoading();
	if (!state) return "absent";
	if (loading || state.status === "cloning") return "loading";
	if (state.status === "error") return "failed";
	return state.onDisk ? "ready" : "absent";
};

export const useToolsView = (type: ToolsType): ToolsView => {
	const status = useToolsStatus();
	const tree = useToolsTree(type, status === "ready");

	// A tree on screen stays while loading: a spinner would shrink the menu and move the items under the pointer.
	if (status === "loading") return tree.nodes ? { kind: "tree", nodes: tree.nodes } : { kind: "loading" };
	if (status !== "ready") return { kind: "unavailable", reason: status };
	if (tree.nodes) return { kind: "tree", nodes: tree.nodes };
	return tree.failed ? { kind: "unavailable", reason: "failed" } : { kind: "loading" };
};
